import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'

import AuthWrapper from '../components/auth/AuthWrapper'
import InlineErrorMessage from '../components/auth/InlineErrorMessage'
import TextButton from '../components/typography/buttons/TextButton'
import Bold from '../components/presentational/Bold'
import ButtonA from '../components/typography/buttons/ButtonA'
import H3 from '../components/typography/headers/H3'
import P2 from '../components/typography/paragraphs/P2'
import JustifyCenter from '../components/presentational/JustifyCenter'
import TextField from '../components/typography/TextField'

import { forgotPassword } from '../actions/forgotpassword'
import { validateEmail } from '../utils/validation'

class ForgotPassword extends Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      emailErrorExists: false,
      displayErrorMessage: false
    }

    this.handleEmailChangeBound = this.handleEmailChange.bind(this)
    this.handleEmailPasswordLinkClickBound =
      this.handleEmailPasswordLinkClick.bind(this)
    this.shouldButtonBeDisabledBound = this.shouldButtonBeDisabled.bind(this)
    this.onReturnToLoginClickBound = this.onReturnToLoginClick.bind(this)
    this.checkForSubmitBound = this.checkForSubmit.bind(this)

    window.scrollTo(0, 0)
  }

  render() {
    const { isLoading, hasSentRequest } = this.props
    return (
      <AuthWrapper>
        {isLoading && (
          <div className="loading" style={{ minHeight: '282px' }} />
        )}
        {!isLoading && !hasSentRequest && (
          <React.Fragment>
            <JustifyCenter>
              <H3 style={{ marginBottom: '15px' }}>Forgot Password</H3>
              <P2 style={{ marginBottom: '24px' }}>
                Don’t worry, it happens to the best of us. Enter your email to
                receive a reset password link.
              </P2>
            </JustifyCenter>
            <form style={{ textAlign: 'left' }}>
              <TextField
                id="email-input"
                label="Email"
                type="email"
                margin="normal"
                value={this.state.email}
                onChange={this.handleEmailChangeBound}
                onKeyPress={this.checkForSubmitBound}
                style={{ marginBottom: '38px' }}
              />
              {this.state.displayErrorMessage && (
                <InlineErrorMessage style={{ bottom: '25px', left: '10px' }}>
                  Please enter a valid email address.
                </InlineErrorMessage>
              )}
              <JustifyCenter>
                <ButtonA
                  type="submit"
                  disabled={this.shouldButtonBeDisabledBound()}
                  onClick={this.handleEmailPasswordLinkClickBound}
                  style={{ marginBottom: '29px', width: 'unset' }}
                >
                  Email Password Link
                </ButtonA>
              </JustifyCenter>
            </form>
          </React.Fragment>
        )}
        {!isLoading && hasSentRequest && (
          <JustifyCenter>
            <H3 style={{ marginBottom: '37px' }}>Please check your email!</H3>
            <P2 style={{ marginBottom: '25px' }}>
              We sent you a secret link to reset your password.
            </P2>
            <P2 style={{ marginBottom: '89px' }}>
              If the email does not arrive soon, check your spam folder. It was
              sent from <Bold>help@questforward.org</Bold>
            </P2>
          </JustifyCenter>
        )}
        <TextButton
          style={{ marginTop: 'auto' }}
          onClick={this.onReturnToLoginClickBound}
          fontSize="13px"
        >
          Return to Login
        </TextButton>
      </AuthWrapper>
    )
  }

  checkForSubmit(e) {
    if (e.which === 13 || e.keyCode === 13) {
      this.handleEmailPasswordLinkClick(e)
    }
  }

  shouldButtonBeDisabled() {
    return !this.state.email || this.state.emailErrorExists
  }

  handleEmailPasswordLinkClick(e) {
    e.preventDefault()
    const { email } = this.state

    if (!validateEmail(email)) {
      this.setState(() => ({
        emailErrorExists: true,
        displayErrorMessage: true
      }))
    } else {
      this.props.dispatch(forgotPassword(email))
    }
  }

  handleEmailChange(e) {
    const email = e.target.value
    this.setState(() => ({
      email: email,
      emailErrorExists: false
    }))
  }

  onReturnToLoginClick() {
    this.props.dispatch(push('/login'))
  }
}

ForgotPassword.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  hasSentRequest: PropTypes.bool.isRequired
}

export const mapStateToProps = state => ({
  isLoading: state.forgotpassword.isSendingRequest,
  hasSentRequest: state.forgotpassword.hasSentRequest
})

export default connect(mapStateToProps)(ForgotPassword)
export { ForgotPassword as ForgotPasswordDisconnected } // pure component - used in tests



// WEBPACK FOOTER //
// ./src/containers/ForgotPassword.js